<template>
  <v-icon
    :color="cellData ? '#65ad45' : '#f44336'"
  >
    {{ cellData ? 'mdi-check-circle' : 'mdi-close-circle' }}
  </v-icon>
</template>

<script>
export default {
  name: 'BooleanCell',

  props: {
    cellData: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
</style>
